module.exports = __webpack_public_path__ + "img/joshuahoy_fun.a0c17619.jpg";